var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatifanalysis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 23,
    viewBox: "0 0 19 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18.1525,
    height: 23,
    fill: "#042b62"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.97303 16.8529C11.3452 16.8529 13.7174 16.8323 16.0896 16.8323V2.06277H2.06271V16.8323C3.01159 16.8117 3.93984 16.8117 4.88872 16.791C4.39366 18.1731 3.89859 19.5552 3.40352 20.9372C5.26002 19.5964 7.11653 18.235 8.97303 16.8529Z",
    stroke: "white",
    strokeWidth: 0.618834,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.16851 11.4897L8.14788 11.1184C8.06537 10.3552 8.31291 9.53005 9.01425 8.68431C9.65371 7.94171 10.0044 7.38476 10.0044 6.76592C10.0044 6.04395 9.55057 5.56951 8.66358 5.54888C8.14788 5.54888 7.59093 5.7139 7.24026 5.98207L6.88959 5.1157C7.3434 4.78565 8.14788 4.55875 8.89048 4.55875C10.4995 4.55875 11.2421 5.54888 11.2421 6.62153C11.2421 7.57041 10.7057 8.27175 10.025 9.05561C9.40618 9.77758 9.17927 10.3964 9.22053 11.1184L9.24116 11.4897H8.16851ZM7.85909 13.47C7.85909 12.9543 8.20977 12.583 8.70483 12.583C9.1999 12.583 9.52995 12.9543 9.52995 13.47C9.52995 13.965 9.1999 14.3363 8.68421 14.3363C8.18914 14.3363 7.85909 13.965 7.85909 13.47Z",
    stroke: "white",
    strokeWidth: 0.618834,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatifanalysis);
export default __webpack_public_path__ + "static/media/whatifanalysis.477c1d51bf030fb72bdf7a4e60a1139b.svg";
export { ForwardRef as ReactComponent };